// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IsHcpIntakeAllowedRequestModelGender {
    static getAttributeTypeMap() {
        return IsHcpIntakeAllowedRequestModelGender.attributeTypeMap;
    }
}
IsHcpIntakeAllowedRequestModelGender.discriminator = undefined;
IsHcpIntakeAllowedRequestModelGender.additionalProperties = false;
IsHcpIntakeAllowedRequestModelGender.attributeTypeMap = [
    {
        "name": "length",
        "baseName": "length",
        "type": "number"
    },
];
//# sourceMappingURL=isHcpIntakeAllowedRequestModelGender.js.map